import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as usersActions from '../store/users/actions';
import * as reducers from '../store/reducers';

import Loading from 'Components/Loading';
import ContentFrame from 'Components/ContentFrame';
import SectionHeader from 'Components/SectionHeader';
import TextBlock from 'Components/TextBlock';
import CreateUserAccount from 'Containers/CreateUserAccount';
import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';
import { ROUTES } from 'Settings/route-strings';

class InvitesPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      requestedTokenValidation: false,
    };
  }

  componentDidMount() {
    this.props.checkInviteTokenValidity(this.props.inviteToken);
    this.setState({ requestedTokenValidation: true });
  }

  componentWillReceiveProps(nextProps) {
    // Check to see if we have an active user and send them on their way.
    if (nextProps.activeUser) {
      // TODO router: use <Redirect />
      window.setTimeout(nextProps.history.replace, 1000, ROUTES.INDEX);
    }
  }

  render() {
    const {
      isInviteTokenBeingValidated,
      isInviteTokenValid,
      inviteToken,
      invitedUser,
      message,
    } = this.props;
    if (isInviteTokenBeingValidated || !this.state.requestedTokenValidation)
      return <Loading />;
    return (
      <main className="Page__content">
        {isInviteTokenValid ? (
          <ContentFrame pageType="transactional" size="medium">
            <SectionHeader
              title={
                <ConnectedFormattedMessage id="create_account_page.title" />
              }
            />
            <CreateUserAccount
              formName="acceptTeacherInvitation"
              invitedUser={invitedUser}
              inviteToken={inviteToken}
            />
          </ContentFrame>
        ) : (
          <ContentFrame pageType="transactional" size="small">
            <SectionHeader
              title={<ConnectedFormattedMessage id="errors.generic_title" />}
              subtitle={
                message.errorCode ? (
                  <ConnectedFormattedMessage
                    id="errors.display_error_code"
                    values={{ error_code: message.errorCode }}
                  />
                ) : null
              }
            />
            <TextBlock
              type="large"
              description={
                <p className="TextBlock__paragraph">
                  <ConnectedFormattedMessage id={message.msgId} />
                </p>
              }
            />
          </ContentFrame>
        )}
      </main>
    );
  }
}

const mapStateToProps = (state, { match: { params } }) => {
  return {
    activeUser: reducers.getActiveUser(state),
    isInviteTokenValid: reducers.isInviteTokenValid(state),
    isInviteTokenBeingValidated: reducers.isInviteTokenBeingValidated(state),
    invitedUser: reducers.getInvitedUser(state),
    inviteToken: decodeURIComponent(params.inviteToken),
    message: reducers.getInviteTokenMessage(state),
  };
};

export default withRouter(connect(mapStateToProps, usersActions)(InvitesPage));
